import { createAction } from 'redux-act';

export const fetchCampaign = createAction('campaign/FETCH_ACTIVE_CAMPAIGN');
export const setCampaign = createAction('campaign/SET_ACTIVE_CAMPAIGN');
export const clearCampaign = createAction('campaign/CLEAR_ACTIVE_CAMPAIGN');
